import { render, staticRenderFns } from "./informal-patients.vue?vue&type=template&id=b34a6258&scoped=true&"
import script from "./informal-patients.vue?vue&type=script&lang=js&"
export * from "./informal-patients.vue?vue&type=script&lang=js&"
import style0 from "./informal-patients.vue?vue&type=style&index=0&id=b34a6258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34a6258",
  null
  
)

export default component.exports